import React, { CSSProperties } from "react";
import { Icon } from "semantic-ui-react";

interface EmailLoginButtonProps {
  onClick?: () => void;
  logoStyle?: Record<string, any>;
  textStyle?: Record<string, any>;
  style?: CSSProperties;
  emailLoginText?: string;
}

const DEFAULT_PROPS = {
  onClick: () => {},
  logoStyle: {},
  textStyle: {},
  style: {},
  emailLoginText: "ลงชื่อเข้าใช้งานด้วยอีเมล",
};

const EmailLoginButton = React.forwardRef<HTMLDivElement, EmailLoginButtonProps>(
  (propsParam: EmailLoginButtonProps, ref) => {
    const props = {
      ...DEFAULT_PROPS,
      ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
    };

    return (
      <div
        className="emailLoginButton"
        onClick={props.onClick}
        ref={ref}
        style={{
          backgroundColor: "white",
          color: "#5DBCD2",
          border: "2px solid #5DBCD2",
          margin: "0 auto",
          height: "40px",
          lineHeight: "38px",
          cursor: "pointer",
          ...props.style,
        }}
      >
        <Icon
          style={{
            padding: "5px",
            float: "left",
            ...props.logoStyle,
          }}
          name="mail"
          size="big"
        />
        <span style={{ margin: "0 10px", ...props.textStyle }}>{props.emailLoginText}</span>
      </div>
    );
  }
);

EmailLoginButton.displayName = "EmailLoginButton";

export default EmailLoginButton;
